var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79995 1.60001C4.3756 1.60001 3.96864 1.76858 3.66858 2.06864C3.36852 2.36869 3.19995 2.77566 3.19995 3.20001V12.8C3.19995 13.2244 3.36852 13.6313 3.66858 13.9314C3.96864 14.2314 4.3756 14.4 4.79995 14.4H11.2C11.6243 14.4 12.0313 14.2314 12.3313 13.9314C12.6314 13.6313 12.8 13.2244 12.8 12.8V5.93121C12.7999 5.50689 12.6312 5.09999 12.3312 4.80001L9.59995 2.06881C9.29996 1.76873 8.89306 1.6001 8.46875 1.60001H4.79995ZM8.79995 6.40001C8.79995 6.18783 8.71567 5.98435 8.56564 5.83432C8.41561 5.68429 8.21212 5.60001 7.99995 5.60001C7.78778 5.60001 7.58429 5.68429 7.43427 5.83432C7.28424 5.98435 7.19995 6.18783 7.19995 6.40001V8.00001H5.59995C5.38778 8.00001 5.18429 8.08429 5.03427 8.23432C4.88424 8.38435 4.79995 8.58783 4.79995 8.80001C4.79995 9.01218 4.88424 9.21566 5.03427 9.36569C5.18429 9.51572 5.38778 9.60001 5.59995 9.60001H7.19995V11.2C7.19995 11.4122 7.28424 11.6157 7.43427 11.7657C7.58429 11.9157 7.78778 12 7.99995 12C8.21212 12 8.41561 11.9157 8.56564 11.7657C8.71567 11.6157 8.79995 11.4122 8.79995 11.2V9.60001H10.4C10.6121 9.60001 10.8156 9.51572 10.9656 9.36569C11.1157 9.21566 11.2 9.01218 11.2 8.80001C11.2 8.58783 11.1157 8.38435 10.9656 8.23432C10.8156 8.08429 10.6121 8.00001 10.4 8.00001H8.79995V6.40001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAdd);
export default __webpack_public_path__ + "static/media/DocumentAdd.3bf663654fd476e40d6e73d4c82ea0e6.svg";
export { ForwardRef as ReactComponent };